import orderIcon from "../assets/images/sidebar/orders.svg";
import customerIcon from "../assets/images/sidebar/customers.svg";
import driverIcon from "../assets/images/sidebar/drivers.svg";
import mapIcon from "../assets/images/sidebar/map.svg";
import storeIcon from "../assets/images/sidebar/stores.svg";
import productIcon from "../assets/images/sidebar/products.svg";
import couponIcon from "../assets/images/sidebar/promotions.svg";
import withdrawalIcon from "../assets/images/sidebar/withdrawals.svg";
import transactionIcon from "../assets/images/sidebar/transactions.svg";
import reportIcon from "../assets/images/sidebar/reports.svg";
import notificationIcon from "../assets/images/sidebar/notifications.svg";
import { getUserType, isFeatureEnabled, isPermissionExist } from "../services";

export const menus = [
  {
    icon: orderIcon,
    title: "Orders",
    path: "/orders",
    state: "order",
    isLink: true,
    isStaff: "order_index",
    children: [
      {
        icon: "📋",
        title: "Support",
        path: "/order-chat-support",
        state: "order",
        isStaff: "order_chat",
        isLink: true,
      },
    ],
  },
  {
    icon: customerIcon,
    title: "Customers",
    path: "/customers",
    state: "customer",
    isLink: true,
    isAdd: "customer_store",
    isStaff: "customer_index",
  },
  {
    icon: driverIcon,
    title: "Drivers",
    path: "/drivers",
    state: "driver",
    isLink: true,
    isAdd: "agent_store",
    isStaff: "agent_index",
    children: [
      {
        icon: "📋",
        title: "Reviews",
        path: "/reviews",
        state: "driver",
        isLink: true,
        isStaff: "agent_reviews",
      },
    ],
  },
  getUserType() && {
    icon: mapIcon,
    title: "Map View",
    path: "/map-view",
    state: "map",
    isLink: true,
    isAdd: false,
    isStaff: "agent_index",
  },
  {
    icon: storeIcon,
    title: "Stores",
    path: "/stores",
    state: "store",
    isLink: true,
    isAdd: "store_store",
    isStaff: "store_index",
    children: [
      {
        icon: "📋",
        title: "Reviews",
        path: "/reviews",
        state: "store",
        isLink: true,
        isStaff: "store_reviews",
      },
      getUserType() && isFeatureEnabled("store_search_log")
        ? {
            icon: "📋",
            title: "Search Logs",
            path: "/store-logs",
            state: "store",
            isLink: true,
          }
        : "",
    ],
  },
  {
    icon: productIcon,
    title: "Products",
    path: "/products",
    state: "product",
    isLink: true,
    isStaff: "product_index",
    children: [
      {
        icon: "📋",
        title: "Categories",
        path: "/categories",
        state: "product",
        isLink: true,
        isStaff: "product_index",
      },
    ],
  },
  {
    icon: couponIcon,
    title: "Promotions",
    path: "/coupons",
    state: "coupon",
    isLink: true,
    isAdd: "coupon_store",
    isStaff: "coupon_index",
    children: [
      {
        icon: "📋",
        title: "Bulk Notifications",
        path: "/bulk-notifications",
        state: "coupon",
        isLink: true,
        isStaff: "promotion_bulk",
      },
      isFeatureEnabled("newsletter")
        ? {
            icon: "📋",
            title: "Email Newsletter",
            path: "/email-newsletter",
            state: "coupon",
            isLink: true,
            isStaff: "newsletter",
          }
        : "",
    ],
  },
  {
    icon: withdrawalIcon,
    title: "Withdrawals",
    state: "withdrawal",
    isLink: false,
    path: "",
    children: [
      {
        icon: "📋",
        title: "Stores",
        path: "/withdrawals/store",
        state: "withdrawal",
        isLink: true,
      },
      {
        icon: "📋",
        title: "Drivers",
        path: "/withdrawals/driver",
        state: "withdrawal",
        isLink: true,
      },
    ],
  },
  {
    icon: transactionIcon,
    title: "Transactions",
    path: "/transactions",
    state: "transaction",
    isLink: true,
    children: [
      {
        icon: "📋",
        title: "Failed Payments",
        path: "/failed-payments/pending",
        state: "transaction",
        isLink: true,
      },
    ],
  },
  {
    icon: reportIcon,
    title: "Reports",
    path: "/reports",
    state: "report",
    isLink: true,
  },
];
